module.exports = __webpack_public_path__ + "static/media/4. Antes que la nada, Óleo y acrílico en tela, 80 x 100 cm, 2018 copy.34d9e352.png";